
const PoppinFont = () => (
    <>
        <link
            href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap"
            rel="stylesheet"
        />
    </>
);

export default PoppinFont;